import { render, staticRenderFns } from "./ResourceList.vue?vue&type=template&id=6ce05a66&scoped=true"
import script from "./ResourceList.vue?vue&type=script&lang=js"
export * from "./ResourceList.vue?vue&type=script&lang=js"
import style1 from "./ResourceList.vue?vue&type=style&index=1&id=6ce05a66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce05a66",
  null
  
)

export default component.exports